jQuery(window).on('load', function () {
    //Defines which fields have to be updated based on the parent one
    //For example, if a user selects state MT, the city select will
    //be updated to show only Montanan cities

    var fieldDependencies = {
        'listing_type': [],
        'property_type': [],
        'building_type': [],
        'state': ['city'],
        'city': [],
        'price_range': [
            'square_footage_min',
            'square_footage_max'
        ]
    };

    var leaseTypes = {
        'full_services': 'Full Service',
        'gross': 'Gross',
        'modified_gross': 'Modified Gross',
        'nnn': 'NNN',
        'modified_net': 'Modified Net',
        'ground_lease': 'Ground Lease'
    };

    var unitDealStatus = {
        'available': 'Available',
        'off_market': 'Off Market',
        'closed': 'Closed',
        'under_contract': 'Under Contract'
    };

    var currentOffset = 0;
    var infiniteScrollHolder;

    //Initializes the forms, elements and change events for the home MLS page
    //and the listing page.
    var initialize = function () {

        switchListView();
        var searchFormLoaded = false;

        if ($(".mls article.listing-template").length > 0) {
            cleanHash();
            initSort();
            initContactBrokerForm();
            initWizard();
            initMenu();
            loadChangeEvents('listing');
            loadInfiniteScroll();
            loadListings();
            loadModels();
            checkHash();
            checkEmptyParams();

            $('.advanced-filter').on('click', function () {
                if (!searchFormLoaded) {
                    searchFormLoaded = true;
                    loadSearchForm('listing');
                    $('#advancedFilter div.modal-content').LoadingOverlay("show",
                        {
                            image: $('body').attr('data-base-url') + "assets/img/loading.png",
                            imageAnimation: '2500ms rotate_left',
                            zIndex: 1005,
                            background: "rgba(255, 255, 255, 0.95)"
                        }
                    );
                }
            });

            // Desktop Only
            if ($(window).width() > 600) {
                initDraggables();
            }

        } else if ($('.mls section#search').length > 0) {
            initMenu();
            loadSearchForm('home');
            loadChangeEvents('home');
        } else {
            initMenu();
        }
    };

    var loadModels = function () {
        $('#read-more').modal({
            ready: function (modal, trigger) { // Callback for Modal open. Modal and trigger parameters available.
                $('#read-more').find('[data-ref="title"]').html($(trigger).attr('data-title'));
                $('#read-more').find('[data-ref="content"]').html($(trigger).attr('data-content'));
            },
            complete: function () {
                $('#read-more').find('[data-ref="title"]').html('');
                $('#read-more').find('[data-ref="content"]').html('');
            }
        });

        $('#advancedFilter').modal({dismissible:false, preventScrolling: true});
    };

    var switchListView = function () {
        if (getCookie('harken-list') === null) {
            setCookie('harken-list', 'grid', 7);
        }

        $('#results').on('click', '.list-toggle .toggle', function () {
            $('.list-toggle .toggle').toggle();
            $('.list-results').toggleClass('list-view');

            var cookie = $('.list-results').hasClass('list-view') ? 'list' : 'grid';

            setCookie('harken-list', cookie, 7);
        });
    };

    //Checks the GET params and get the value being set to listing_type if any
    var getListingType = function (page) {
        if (page === undefined) {
            return $.query.get('listing_type');
        } else if (page === 'home') {
            return $("input:radio[name='listing_type']:checked").val();
        }
    };

    //Checks the GET params and get the value being set to property_type if any
    var getPropertyType = function (page) {
        if (page === undefined) {
            return $.query.get('property_type');
        } else if (page === 'home') {
            return $('select[name="property_type[]"]').val().join();
        }
    };

    //Checks the GET params and get the value being set to state if any
    var getState = function () {
        var param = getParameterByName('state');
        return param && param !== '' ? param : $('select[name="state"]').find(":selected").val();
    };

    //Checks the GET params and get the value being set to city if any
    var getCity = function () {
        var param = getParameterByName('city');
        return param && param !== '' ? param : $('select[name="city[]"]').val().join();
    };

    //Update the GET query in the URL with the input value of the field being passed
    var updateSearchQuery = function (attribute, value, skipRefresh) {
        if ($("article.listing-template").length > 0) {
            if (value && value.length > 0) {
                $.query = $.query.set(attribute, value);
                history.pushState(null, '', window.location.pathname + $.query.set(attribute, value));
            } else {
                //If the value being sent is empty, then we unset the GET params being passed
                cleanSearchQuery(attribute);
            }

            //If skip refresh was not set to FALSE,
            //then the listings will be refreshed
            if (skipRefresh === undefined) {
                currentOffset = 0;
                MapController.Listings.bounds.swLat = null;
                MapController.Listings.bounds.swLng = null;
                MapController.Listings.bounds.neLat = null;
                MapController.Listings.bounds.neLng = null;
                loadListings();
            }
        }
    };

    //If no attribute is passed, clean the whole GET params from URL
    //If a attribute is passed, remove from URL
    var cleanSearchQuery = function (attribute) {

        if (attribute !== undefined) {
            //Remove the specific attribute from the GET params list and set
            //the attribute to its default if any
            if ($("article.listing-template").length > 0) {
                $.query = $.query.REMOVE(attribute);
                setInputDefault(attribute);
            }
        } else {
            //Empty the query string with GET params
            $.query = $.query.empty();
        }

        history.pushState(null, '', window.location.pathname + $.query);
    };

    /*Load the change events for the searching fields. The events
    * work in a cascade way, which means that based on the order
    * they are in the search modal, a field with a bigger scope,
    * when changed, will update the fields with a more narrow
    * scope. For example, a property type change (retail/lease),
    * will update the state and cities select.*/
    var loadChangeEvents = function (page) {
        if (page === 'home') {
            $("input[type=radio][name='listing_type']").change(function () {
               /* loadStates('home');
                loadCities('home'); */
            });

            $("select[name='property_type[]']").change(_.debounce(function () {
            /*    loadStates('home');
                loadCities('home'); */
                $(this).material_select();
            }, 1500));

            $("select[name='state']").change(function () {
                loadCities('home');
            });

            $("select[name='city[]']").change(_.debounce(function () {
                $(this).material_select();
            }, 1500));

        } else if (page === 'listing') {
            $("select[name='listing_type']").change(function () {
                clearSearch('listing_type');
                updateSearchQuery('listing_type', $(this).val());
            });

            $("select[name='property_type[]']").change(_.debounce(function () {
                clearSearch('property_type');
                updateSearchQuery('property_type', $(this).val().join());
                $(this).material_select();
            }, 1500));

            $("select[name='building_type']").change(function () {
                clearSearch();
                updateSearchQuery('building_type', $(this).val());
            });

            var previousState;
            $("select[name='state']").on('focus', function () {
                previousState = this.value;
            }).change(function () {
                if(previousState !== this.value) {
                    clearSearch('state');
                    updateSearchQuery('state', $(this).val());
                    loadCities();
                    loadPrices();
                    loadSqFt();
                }

                previousState = this.value;
            });

            $("select[name='city[]']").change(_.debounce(function () {
                clearSearch('city');
                updateSearchQuery('city', $(this).val().join());
                $(this).material_select();
            }, 1500));

            $("#price_range-min").change(function () {
                var value = $(this).val().replace(/\D/g, '');
                clearSearch('price_range_min');
                updateSearchQuery('price_range_min', value);
            });

            $("#price_range-max").change(function () {
                var value = $(this).val().replace(/\D/g, '');
                clearSearch('price_range_max');
                updateSearchQuery('price_range_max', value);
            });

            $("#square_footage-min").change(function () {
                var value = $(this).val().replace(/\D/g, '');
                clearSearch('square_footage_min');
                updateSearchQuery('square_footage_min', value);
            });

            $("#square_footage-max").change(function () {
                var value = $(this).val().replace(/\D/g, '');
                clearSearch('square_footage_max');
                updateSearchQuery('square_footage_max', value);
            });

            $("#keywords").change(function () {
                clearSearch('keywords');
                updateSearchQuery('keywords', $(this).val());
            });

            $("button#clear-filters").click(function () {
                clearFilters();
            });

            $("a#clear-filters-link").click(function (e) {
                e.preventDefault();
                e.stopPropagation();
                clearFilters();
            });
        }

        iosFix();
    };

    var iosFix = function() {
        $(document).on('touchstart', function (e) {
            var target = $(e.target);
            if (!target.is("span")) { //checking if you are tapping on items in multiple select or not
                $(document).trigger('click'); //if you are tapping outside multiple select close it
                $(':focus').blur(); //focus out for multiple select so you can choose another or the same (in case you have more multiple selects on page)
            } else {
                //nothing or fire another event
            }
        });
    };

    var showClearFilterLink = function () {
        $("a#clear-filters-link").parent().removeClass('hide');
    };

    var hideShowClearFilterLink = function () {
        $("a#clear-filters-link").parent().addClass('hide');
    };

    var checkClearFilterLink = function () {
        if (isEmpty($.query.get())) {
            hideShowClearFilterLink();
        } else {
            showClearFilterLink();
        }
    };

    var clearFilters = function () {
        clearSearch();
        cleanSearchQuery('listing_type');
        cleanSearchQuery('property_type');
        cleanSearchQuery('building_type');
        cleanSearchQuery('state');
        cleanSearchQuery('city');
        cleanSearchQuery('price_range_min');
        cleanSearchQuery('square_footage_min');
        cleanSearchQuery('price_range_max');
        cleanSearchQuery('square_footage_max');
        cleanSearchQuery('brokerId');
        cleanSearchQuery('keywords');
        loadPrices(); //the default min and max are set
        loadSqFt(); //the default min and max are set
        currentOffset = 0;
        MapController.Listings.bounds.swLat = null;
        MapController.Listings.bounds.swLng = null;
        MapController.Listings.bounds.neLat = null;
        MapController.Listings.bounds.neLng = null;
        loadListings();
    };

    var clearSearch = function (field) {
        $("section.list-results").empty();
        MapController.Listings.clean();

        if (field !== undefined) {
            if (fieldDependencies[field]) {
                $(fieldDependencies[field]).each(function (index, value) {
                    cleanSearchQuery(value);
                });
            }
        }
    };

    var loadSearchForm = function (page) {
        if (page === 'listing') {
            Promise.all([
                loadListingType(),
                loadPropertyType(),
                loadBuildingType(),
                loadStates(),
                loadCities(),
                loadPrices(),
                loadSqFt(),
                loadKeywords()
            ]).then(function (result) {
                $('#advancedFilter div.modal-content').LoadingOverlay('hide');
                reinitCitySelect();
                reinitPropertyType();
            });
        } else if (page === 'home') {
            loadPropertyType();
            loadStates();
            loadCities();
        }
    };

    var loadListingType = function () {
        return new Promise(function (resolve, reject) {
        $.get($("body").data("base-url") + 'mls/get_listing_type')
            .done(function (data) {
                fillSelect(data, 'listing_type', 'For Sale & Lease');
                resolve();
            });
        });
    };

    var loadPropertyType = function (page) {
        return new Promise(function (resolve, reject) {
            $.get($("body").data("base-url") + 'mls/get_property_types', {
                listingType: getListingType(page)
            }).done(function (data) {
                fillMultipleSelect(data, 'property_type', 'Show All');
                resolve();
            });
        });
    };

    var loadBuildingType = function () {
        return new Promise(function (resolve, reject) {
            $.get($("body").data("base-url") + 'mls/get_building_type', {
                listingType: getListingType(),
                propertyType: getPropertyType()
            }).done(function (data) {
                fillSelect(data, 'building_type', 'Show All');
                resolve();
            });
        });
    };

    var loadStates = function (page) {
        return new Promise(function (resolve, reject) {
            $.get($("body").data("base-url") + 'mls/get_states', {
                listingType: getListingType(page),
                propertyType: getPropertyType(page)
            }).done(function (data) {
                fillSelect(data, 'state', 'State');
                resolve();
            });
        });
    };

    var reinitCitySelect = function(page) {
        $("[data-select='city']").find('ul.dropdown-content li').first().click(function(){
            $("[data-select='city']").find('ul.dropdown-content li:not(:first-child)').each(function(index) {
                $(this).find("input[type=checkbox]").prop("checked", false);
            });

            $("select[name='city[]']").val('');
            $("select[name='city[]']").material_select();
            if(page !== 'home') {
                clearSearch('city');
                updateSearchQuery('city');
            }
        });
    };

    var reinitPropertyType = function(page) {
        $("[data-select='property_type']").find('ul.dropdown-content li').first().click(function(){
            $("[data-select='property_type']").find('ul.dropdown-content li:not(:first-child)').each(function(index) {
                $(this).find("input[type=checkbox]").prop("checked", false);
            });

            $("select[name='property_type[]']").val('');
            $("select[name='property_type[]']").material_select();

            if(page !== 'home') {
                clearSearch('property_type');
                updateSearchQuery('property_type');
            }
        });
    };

    var loadCities = function (page) {
        return new Promise(function (resolve, reject) {
            if (getState() && getState() !== '') {
                var params = {
                    state: getState()
                };

                if(page === undefined) {
                    params.listingType = getListingType(page);
                    params.propertyType = getPropertyType(page);
                }

                $.get($("body").data("base-url") + 'mls/get_cities', params).done(function (data) {
                    fillMultipleSelect(data, 'city', 'Select a City');

                    // When state is selected, update and enable city
                    $('select[name="city[]"]')
                        .prop('disabled', null)
                        .material_select();

                    resolve();

                    reinitCitySelect(page);
                });
            } else {
                reinitCitySelect(page);
                resolve();
            }
        });
    };

    var loadPrices = function () {
        return new Promise(function (resolve, reject) {
            $.get($("body").data("base-url") + 'mls/get_prices', {
                listingType: getListingType(),
                propertyType: getPropertyType(),
                state: getState(),
                city: getCity()
            }).done(function (data) {
                fillRange(data, 'price_range');
                resolve();
            });
        });
    };

    var loadSqFt = function () {
        return new Promise(function (resolve, reject) {
            $.get($("body").data("base-url") + 'mls/get_sq_ft', {
                listingType: getListingType(),
                propertyType: getPropertyType(),
                state: getState(),
                city: getCity()
            }).done(function (data) {
                fillRange(data, 'square_footage');
                resolve();
            });
        });
    };

    var loadKeywords = function () {
        return new Promise(function (resolve, reject) {
            var keywords = getUrlParameter('keywords');

            if (keywords && keywords.length > 0) {
                if ($("#keywords").length > 0) {
                    var words = keywords.split(',');

                    $.each(words, function (key, value) {
                        $('#keywords').materialtags('add', value.replace(/\+/g, " "));
                    });
                }
            }

            resolve();
        });
    };

    var initDraggables = function () {
        interact('.draggable')
            .draggable({
                allowFrom: '.modal-header',
                // enable inertial throwing
                inertia: true,
                // keep the element within the area of it's parent
                restrict: {
                    restriction: "parent",
                    endOnly: true,
                    elementRect: {top: 0, left: 0, bottom: 1, right: 1}
                },
                // enable autoScroll
                autoScroll: true,

                // call this function on every dragmove event
                onmove: dragMoveListener,
                // call this function on every dragend event
                onend: function (event) {
                    var textEl = event.target.querySelector('p');
                    /* jshint ignore:start */
                    textEl && (textEl.textContent = 'moved a distance of ' + (Math.sqrt(Math.pow(event.pageX - event.x0, 2) + Math.pow(event.pageY - event.y0, 2) | 0)).toFixed(2) + 'px');
                    /* jshint ignore:end */
                }
            });

        function dragMoveListener(event) {
            var target = event.target,
                // keep the dragged position in the data-x/data-y attributes
                x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx,
                y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;

            // translate the element
            target.style.webkitTransform =
                target.style.transform =
                    'translate(' + x + 'px, ' + y + 'px)';

            // update the position attributes
            target.setAttribute('data-x', x);
            target.setAttribute('data-y', y);
        }

        // this is used later in the resizing and gesture demos
        window.dragMoveListener = dragMoveListener;
    };

    var initSort = function () {
        var select = $("select#sort-properties");

        if (($.query.get('order') && $.query.get('order').length > 0) && ($.query.get('dir') && $.query.get('dir').length > 0)) {
            if ($("select#sort-properties option[value='" + $.query.get('order') + "=" + $.query.get('dir') + "']").length !== 0) {
                select.val($.query.get('order') + "=" + $.query.get('dir'));
                select.material_select();
            }
        } else {
            select.val("");
            select.material_select();
        }

        select.change(function () {
            var sort = $(this).val().split('=');
            if (sort.length > 1) {
                clearSearch();
                updateSearchQuery('order', sort[0], true);
                updateSearchQuery('dir', sort[1]);
            } else {
                clearSearch();
                cleanSearchQuery('order');
                cleanSearchQuery('dir');
                loadListings();
            }
        });
    };

    var initModal = function () {
        $('a#inquire-broker').click(function () {
            var propertyId = $(this).attr('data-property-id');
            var brokerId = $(this).attr('data-broker-id');
            var companyName = $(this).attr('data-company-name');

            $.ajax({
                url: $("body").data("base-url") + 'mls/get_broker',
                data: {propertyId: propertyId, brokerId: brokerId},
                async: true,
                success: function (responseText) {
                    var data = JSON.parse(responseText);

                    data.company_name = companyName;
                    data.brokerId = brokerId;
                    data.propertyId = propertyId;

                    var brokerImg = data.profile_image_url !== null ? $('body').attr('data-cdn-url') + data.profile_image_url : 'no-image.png';
                    var el = $('#brokerContact');

                    //First name and last name
                    if((data.first_name && data.first_name.length > 0) || (data.last_name && data.last_name.length > 0)) {
                        el.find("[data-ref='broker_name']").parent().removeClass('hide');
                        $('#inquire-broker [data-ref=broker_name]').text(data.first_name + " " + data.last_name);
                    } else {
                        el.find("[data-ref='broker_name']").parent().addClass('hide');
                        $('#inquire-broker [data-ref=broker_name]').text('');
                    }

                    //Company name
                    if(data.company_name && data.company_name.length > 0) {
                        el.find("[data-ref='company_name']").parent().removeClass('hide');
                        $('#inquire-broker [data-ref=company_name]').text(data.company_name);
                    } else {
                        el.find("[data-ref='company_name']").parent().addClass('hide');
                        $('#inquire-broker [data-ref=company_name]').text('');
                    }

                    //Phone Number
                    if(data.phone_number && data.phone_number.length > 0) {
                        el.find("[data-ref='phone_number']").parent().addClass('hide');
                        $('#inquire-broker [data-ref=phone_number]').text(data.phone_number).attr('href', 'tel:' + data.phone_number);
                    } else {
                        el.find("[data-ref='phone_number']").parent().parent().addClass('hide');
                        $('#inquire-broker [data-ref=phone_number]').text();
                    }

                    var secondary_brokers = data.secondary_brokers;

                    //Broker > Secondary Brokers
                    if (secondary_brokers && secondary_brokers.length > 0) {
                        el.find('[data-ref=secondary_brokers]').parent().removeClass('hide');
                        var names = [];

                        $(secondary_brokers).each(function(index, obj) {
                            names.push(obj.first_name + ' ' + obj.last_name);
                        });

                        el.find('[data-ref=secondary_brokers]').html(names.join('<br/>'));
                    } else {
                        el.find('[data-ref=secondary_brokers]').parent().addClass('hide');
                        el.find('[data-ref=secondary_brokers]').text('');
                    }

                    $('#inquire-broker [data-ref=profile_image_url]').attr('src', brokerImg);
                    $('#inquire-contact [data-ref=brokerId]').val(data.brokerId);
                    $('#inquire-contact [data-ref=propertyId]').val(data.propertyId);

                    $('#brokerContact').modal('open');
                }
            });
        });


        $("button#submit-contact-broker").click(function () {
            var form = $('form#inquire-broker-form');

            event.preventDefault();

            if (form.valid()) {
                $.get(form.attr('action'), form.serializeArray())
                    .done(function (responseText) {
                        var data = JSON.parse(responseText);
                        if (data.status === true) {
                            Materialize.toast(data.message, 4000);
                        }

                        $('#brokerContact').modal('close');
                        clearContactBrokerModal();
                    });
            }
        });
    };

    var clearContactBrokerModal = function () {
        $('#inquire-broker [data-ref=broker_name]').text('');
        $('#inquire-broker [data-ref=company_name]').text('');
        $('#inquire-broker [data-ref=phone_number]').text('').attr('href', '#!');
        $('#inquire-broker [data-ref=profile_image_url]').attr('src', '');
        $('#inquire-contact [data-ref=brokerId]').val('');
        $('#inquire-contact [data-ref=propertyId]').val('');
    };

    var fillRange = function (response, name) {

        var data = JSON.parse(response);

        //Ids from input elements for min and max
        var minElem = '#' + name + '-min';
        var maxElem = '#' + name + '-max';

        //URL params for min and max
        var minUrl = getUrlParameter(name + '_min');
        var maxUrl = getUrlParameter(name + '_max');

        //If the URL params is set, set field with that value
        var min = maskNumberCommas(minUrl && minUrl.length > 0 ? minUrl : 0);

        $(minElem).val(min);

        //If the URL params is set, set field with that value
        var max = maskNumberCommas(maxUrl && maxUrl.length > 0 ? maxUrl : null);

        $(maxElem).val(max);


        //If label is not active, activate it, so the label won't be showing in front of the amount
        if (!$(minElem).parent().find('label').hasClass('active')) {
            $(minElem).parent().find('label').addClass('active');
        }

        //If label is not active, activate it, so the label won't be showing in front of the amount
        if (!$(maxElem).parent().find('label').hasClass('active')) {
            $(maxElem).parent().find('label').addClass('active');
        }
    };

    var setInputDefault = function (name) {
        if(name === 'property_type') {
            name = 'property_type[]';
        } else if(name === 'city') {
            name = 'city[]';
        }

        var select = $('select[name="' + name + '"]');

        //Setting every select to its default value
        if (select) {
            select.val("");
            select.material_select();
        }

        //Removing keywords from keywords input by reseting, so
        //a call to get_listings won't be triggered
        if (name === 'keywords') {
            var keywords = $('#' + name);

            if (keywords) {
                keywords.materialtags('destroy');
                keywords.val('');
                keywords.materialtags();
            }
        }
    };

    var fillSelect = function (data, name, defaultText) {
        var response = JSON.parse(data);

        var select = $('select[name="' + name + '"]');

        if (select) {
            select.find('option').remove();

            select.append($("<option value>" + defaultText + "</option>"));

            $(response).each(function (index, instance) {
                if (instance.val && instance.text) {
                    select.append($('<option>', {value: instance.val, text: instance.text}));
                }
            });

            var value = getUrlParameter(name);

            if (value && value.length > 0) {
                if ($("select[name='" + name + "'] option[value='" + value + "']").length > 0) {
                    select.val(value);
                }
            }

            select.material_select();

            if ($("select[name='" + name + "'] option[value='" + $.query.get(name) + "']").length == 0) {
                cleanSearchQuery(name);
            }
        }
    };

    var fillMultipleSelect = function (data, name, defaultText) {
        var response = JSON.parse(data);

        var select = $('select[name="' + name + '[]"]');

        if (select) {
            select.find('option').remove();

            select.append($("<option value disabled selected>" + defaultText + "</option>"));

            $(response).each(function (index, instance) {
                if (instance.val && instance.text) {
                    select.append($('<option>', {value: instance.val, text: instance.text}));
                }
            });

            var value = getUrlParameter(name);

            var values = [];
            if (value && value.length > 0) {
                values = value.split(",");
                select.val(values);

                values.forEach(function (item) {
                    if ($("select[name='" + name + "[]'] option[value='" + item + "']").length === 0) {
                        cleanSearchQuery(name);
                    }
                });
            } else {
                cleanSearchQuery(name);
            }

            select.material_select();
        }
    };

    var getParams = function () {
        return {
            listingType: $.query.get('listing_type'),
            propertyType: $.query.get('property_type') === 'true'? undefined : $.query.get('property_type'),
            state: $.query.get('state'),
            city: $.query.get('city'),
            buildingType: $.query.get('building_type'),
            priceMin: $.query.get('price_range_min'),
            priceMax: $.query.get('price_range_max'),
            sqFtMin: $.query.get('square_footage_min'),
            sqFtMax: $.query.get('square_footage_max'),
            keywords: $.query.get('keywords'),
            brokerId: $.query.get('brokerId'),
            offset: $(".list-results article:not(.hide)").length,
            order: $.query.get('order'),
            dir: $.query.get('dir')
        };
    };

    var loadListings = function (ignoreSearch) {
        var totalListings = parseInt($('[data-ref=total_of_listings]').attr('data-total'));
        var checktime = $('[data-ref=total_of_listings]').attr('data-checktime');
        var totalMarkers =  $('[data-ref=total_of_listings]').attr('data-total-markers');

        //Has all listings for the current search been loaded?
        var hasAllResultsBeenLoaded = ($(".list-results article:not(.hide)").length < totalListings) || totalListings === 0 || isNaN(totalListings);
        var isMarkersTotalGreaterThanLoadedListings = totalListings < totalMarkers;

        if ((hasAllResultsBeenLoaded || isMarkersTotalGreaterThanLoadedListings) && ((isNaN(checktime) || (Date.now() - parseInt(checktime) > 1000)))) {
            $('[data-ref=total_of_listings]').attr('data-checktime', Date.now());
            startLoading('#results');

            var listingContainer = $("section.list-results");
            var params = getParams();

            var isMapSearch = false;

            if (MapController.Listings.bounds.swLat && MapController.Listings.bounds.swLng && MapController.Listings.bounds.neLat && MapController.Listings.bounds.neLng) {
                params.swLat = MapController.Listings.bounds.swLat;
                params.swLng = MapController.Listings.bounds.swLng;
                params.neLat = MapController.Listings.bounds.neLat;
                params.neLng = MapController.Listings.bounds.neLng;
                isMapSearch = true;
            }

            if (listingContainer) {
                $.get($("body").data("base-url") + 'mls/get_listings', params)
                    .done(function (data) {

                        var response = JSON.parse(data);

                        //Create property cards and markers in the map
                        $(response.listings).each(function (index, instance) {
                            if($.inArray(instance.id.toString(),getPropertiesIds()) === -1) {
                                instance.index = index;

                                loadListing(instance, listingContainer);
                            }
                        });

                        // If 'coordinates' are supplied, then run through all of those
                        if (response.coordinates && !isMapSearch) {
                            MapController.Listings.resetMarkers();

                            $(response.coordinates).each(function (index, instance) {
                                MapController.Listings.addListing(instance);
                            });
                        }

                        //Set total of listings
                        if (response.totalListings === 1) {
                            $('[data-ref=total_of_listings]').text("1 Result Found");
                        } else {
                            $('[data-ref=total_of_listings]').text(response.totalListings + " Results Found");
                        }

                        //Remove loading overlay and initialize the buttons in the new cards
                        stopLoading('#results');
                        initModal();
                        initDrawer();

                        MLSController.isLoadingListings = false;
                        MapController.Listings.firstBounds = false;

                        //If no properties were appended to the view, then show No Results Found message
                        if ($("section.list-results article").length === 0) {
                            if ($(".no-results-found").length === 0) {
                                listingContainer.append("<div class='no-results-found'><p><i class='large  material-icons dp48'>search</i></p><p>No Results Found</p></div>");
                            }
                        }

                        MapController.Listings.checkMap();

                        if(!isMapSearch) {
                            MapController.Listings.isSearch = true;
                            MapController.Listings.fitBounds();
                        } else {
                            MapController.Listings.isSearch = false;
                        }


                        $('[data-ref=total_of_listings]').attr('data-total', response.totalListings);

                        refreshScroll();
                        checkClearFilterLink();

                        SurveyMarket.init();
                        reinitCitySelect();
                        reinitPropertyType();
                    });
            }
        }
    };

    var getPropertiesIds = function() {
        var IDs = [];
        $('.list-results').find('article').find('[data-id]').each(function(index, el){ IDs.push($(el).attr('data-id')); });
        return IDs;
    };

    var loadListing = function (data, listingContainer) {
        var listing = $("article.listing-template").clone().removeClass("listing-template").removeClass('hide');

        var buildingSize = data.building_size;
        if (data.building_size_suites_parcels && data.building_size_suites_parcels.length > 0 && parseInt(data.building_size_suites_parcels) !== 0) {
            data.building_size = data.building_size_suites_parcels;
        }

        if (typeof data.listing_type === 'string' && Utils.contains(data.listing_type, 'sale') && Utils.contains(data.listing_type, 'lease') && buildingSize) {
            data.building_size = buildingSize;
        }

        if (data.listing_image_url.length === 0) {
            data.listing_image_url = $('body').attr('data-base-url') + "assets/img/default-placeholder.png";
        } else {
            data.listing_image_url = Utils.imageUrl(data.listing_image_url);
        }

        var template = listing[0].outerHTML;

        var askingPrice = data.asking_price;
        if (typeof data.listing_type === 'string' && data.listing_type.toLowerCase() === 'lease' && data.asking_price_psf !== null) {
            data.asking_price = data.asking_price_psf;
        } else if (typeof data.listing_type === 'string' && data.listing_type.toLowerCase() === 'sale' && data.asking_price !== null) {
            data.asking_price = askingPrice;
        } else if (typeof data.listing_type === 'string' && Utils.contains(data.listing_type, 'sale') && Utils.contains(data.listing_type, 'lease')) {
            if (data.asking_price_psf !== null) {
                data.asking_price = data.asking_price_psf;
            } else if (data.asking_price !== null) {
                data.asking_price = askingPrice;
            } else {
                data.asking_price = 'Price Not Disclosed';
            }
        } else {
            data.asking_price = 'Price Not Disclosed';
        }

        if (data.asking_price === 'Price Not Disclosed' && data.building_price_suites_parcels && parseInt(data.building_price_suites_parcels.replace(/\D/g, '')) > 0) {
            data.asking_price = data.building_price_suites_parcels;
        }

        if (data.street_address === null) {
            data.street_address = 'Address Not Disclosed';
        }

        if (data.property_class.length === 0) {
            data.property_class = '';
        } else {
            data.property_class = data.property_class + ' Building';
        }

        template = fill(data, template);

        listingContainer.append($(template).hide().delay(100).fadeIn('slow'));
    };

    var mapFrequency = function (code) {
        switch (code) {
            case 'sf_yr':
                return "SF/Yr";
            case 'annually':
                return "Yr";
            case 'sf_mo':
                return "SF/Mo";
            case 'monthly':
                return "Mo";
            default:
                return false;
        }
    };

    var loadInfiniteScroll = function () {
        if ($("#results".length)) {
            // Keeping the Scrollable state separate
            $("#results .wrapper").slimScroll({
                height: $("#results").outerHeight() + 'px',
                distance: '0',
                railBorderRadius: '0',
                railVisible: true,
                alwaysVisible: true,
                allowPageScroll: true,
                touchScrollStep: 50
            }).bind('slimscroll', function (e, pos) {
                var totalListings = parseInt($('[data-ref=total_of_listings]').attr('data-total'));
                var currentOffset = $('section.list-results').children().length;

                if (pos === 'bottom' && currentOffset < totalListings) {
                    clearTimeout(infiniteScrollHolder);
                    MLSController.isInfiniteScroll = true;
                    infiniteScrollHolder = setTimeout(MLSController.loadListings(), 1000);
                }
            });
        }
    };

    var refreshScroll = function () {
        $("#results .wrapper").slimScroll({
            height: 'auto',
            distance: '0',
            railBorderRadius: '0',
            railVisible: true,
            alwaysVisible: true,
            touchScrollStep: 50
        });
    };


    var fill = function (data, template) {
        Object.keys(data).forEach(function (key) {
            var placeholder = "{{" + key + "}}";
            var value = data[key];
            if (value === null) {
                value = '';
            }

            while (template.indexOf(placeholder) !== -1) {
                template = template.replace(placeholder, value);
            }
        });
        return template;
    };

    var getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = decodeURIComponent(window.location.search.substring(1)),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : sParameterName[1];
            }
        }
    };

    var initDrawer = function () {
        $('.carousel.carousel-slider').carousel({fullWidth: true});
    };

    var fillDetails = function (data) {
        try {
            var listingDetail = $('#listing-detail');
            var body = $('body');

            /*Property section*/
            var property = data.property;


            if (property.building_size_suites_parcels && property.building_size_suites_parcels.length > 0) {
                property.building_size = property.building_size_suites_parcels;
            }

            var askingPrice = property.asking_price;

            if (typeof property.listing_type === 'string' && Utils.contains(property.listing_type, 'lease') && property.asking_price_psf !== null) {
                property.asking_price = property.asking_price_psf;
            } else if (typeof property.listing_type === 'string' && Utils.contains(property.listing_type, 'sale') && property.asking_price !== null) {
                property.asking_price = property.full_price;
            } else if (typeof property.listing_type === 'string' && Utils.contains(property.listing_type, 'sale') && Utils.contains(property.listing_type, 'lease')) {
                if (property.asking_price_psf !== null) {
                    property.asking_price = property.asking_price_psf;
                } else if (property.asking_price !== null) {
                    property.asking_price = askingPrice;
                } else {
                    property.asking_price = 'Price Not Disclosed';
                }
            } else {
                property.asking_price = 'Price Not Disclosed';
            }

            if (property.asking_price === 'Price Not Disclosed' && property.building_price_suites_parcels && parseInt(property.building_price_suites_parcels.replace(/\D/g, '')) > 0) {
                property.asking_price = property.building_price_suites_parcels;
            }

            // Check whether notes and descriptions are provided
            if (property.description === null) {
                property.description = 'No description provided.';
            } else {
                property.description = property.description.replace(/(?:\\[rn])+/g, '<br/>');
                property.description = Utils.truncate(property.description, 500, 'Property Description', 'p');
            }

            if (property.notes === null) {
                property.notes = 'No sales notes provided.';
            } else {
                property.notes = property.notes.replace(/(?:\\[rn])+/g, '<br/>');
            }

            if (property.status && property.status.toString() === 'UNDER_CONTRACT') {
                $('.property-status').show();
            } else {
                $('.property-status').hide();
            }

            listingDetail.find('.content [data-ref=zoning_type]').html(property.zoning_type);
            listingDetail.find('.content [data-ref=property_class]').html(property.property_class);
            listingDetail.find('.content [data-ref=sale_type]').html(property.listing_type);
            listingDetail.find('.content [data-ref=land_size]').html(property.land_size);
            if (property.building_size) {
                if(Utils.contains(property.building_size,'a.')) {
                    property.building_size = '';
                } else  {
                    listingDetail.find('.content [data-ref=building_size]').html(property.building_size);
                }
            } else {
                listingDetail.find('.content [data-ref=building_size]').html(property.building_size_suites_parcels);
            }
            listingDetail.find('.content [data-ref=n_stories]').html(property.no_stories);
            listingDetail.find('.content [data-ref=year_built]').html(property.year_built);
            listingDetail.find('.content [data-ref=business_name]').html(property.business_name);
            listingDetail.find('.content [data-ref=street_address]').text((property.street_address !== null ? property.street_address : 'No Address Provided'));
            listingDetail.find('.content [data-ref=city]').text(property.city);
            listingDetail.find('.content [data-ref=state]').text(property.state);
            listingDetail.find('.content [data-ref=zipcode]').text(property.zipcode);
            listingDetail.find('.content [data-ref=date_listed]').text(property.listing_created);

            listingDetail.find('.content [data-ref=asking_price]').text(property.asking_price);
            listingDetail.find('.content [data-ref=description]').html(property.description);
            listingDetail.find('.content [data-ref=notes]').html(property.notes);

            //Attachments
            if (property.attachments) {
                listingDetail.find('.content [data-ref=attachments]').parent().show();

                var html = "<ul>";
                $(property.attachments).each(function (index, obj) {
                    if(obj.origin === 'BUILDOUT_DOCUMENTS') {
                        html += "<li>";
                        html += '<a href="' + obj.dir + '" class="tooltipped" data-position="bottom" data-tooltip="' + (obj.description ? obj.description : 'Click here to download.') + '" target="_blank"><p><span>' + (obj.title ? obj.title : (obj.description ? obj.description : obj.filename)) + '</span><i class="material-icons">file_download</i></p></a>';
                        html += "</li>";
                    } else {
                        html += "<li>";
                        html += '<a href="' + $('body').attr('data-cdn-url') + obj.dir + '" class="tooltipped" data-position="bottom" data-tooltip="' + (obj.description ? obj.description : 'Click here to download.') + '" target="_blank"><p><span>' + (obj.title ? obj.title : (obj.description ? obj.description : obj.filename)) + '</span><i class="material-icons">file_download</i></p></a>';
                        html += "</li>";
                    }
                });

                html += "</ul>";
                listingDetail.find('.content [data-ref=attachments]').html(html);
                listingDetail.find('.content [data-ref=attachments]').find('.tooltipped').tooltip();
            } else {
                listingDetail.find('.content [data-ref=attachments]').parent().hide();
                listingDetail.find('.content [data-ref=attachments]').empty();
            }

            listingDetail.find('.content [data-ref=parking]').text(property.parking);

            property.zoning = Utils.truncate(property.zoning_description, 500, 'Zoning Description', 'p');
            listingDetail.find('.content [data-ref=zoning_description]').html(property.zoning_description);
            listingDetail.find('.content [data-ref=apn]').text(property.parcel_id_apn);

            //Suites and parcels
            var wrapper = listingDetail.find('.content [data-ref=suites-parcels]');

            if (property.suites_parcels && property.suites_parcels.length > 0) {

                // Determine the type of unit
                var unit = property.suites_parcels_type.toString();

                if (unit === 'SUITE') {
                    listingDetail
                        .find('.content [data-ref=suites-parcels-title]')
                        .text(property.suites_parcels.length === 1 ? 'Suite' : 'Suites');
                } else if (unit === 'PARCEL') {
                    listingDetail
                        .find('.content [data-ref=suites-parcels-title]')
                        .text(property.suites_parcels.length === 1 ? 'Parcel' : 'Parcels');
                }


                // Clone the unit element and populate it with ref attributes
                var ul = listingDetail.find('[data-ref=suites-parcels] ul');
                var clone = ul.children('li[data-ref=unit-clone]').clone();

                // Empty any pre-existing units
                ul.find('li:not([data-ref])').remove();

                $(property.suites_parcels).each(function (index, obj) {

                    var copy = clone.clone();

                    // Remove clone attributes
                    copy.removeAttr('data-ref').removeClass('hide');

                    // Assign the object to it's respective data reference point
                    if (obj.name && obj.name.length > 0 && obj.name.toLowerCase() !== 'none') {
                        copy.find('[data-ref=unit-title]').text(obj.name);
                    } else {
                        copy.find('[data-ref=unit-title]').remove();
                    }

                    if (obj.description && obj.description.length > 0) {
                        copy.find('[data-ref=unit-description]').text(obj.description);
                    } else {
                        copy.find('[data-ref=unit-description]').prev().remove();
                        copy.find('[data-ref=unit-description]').remove();
                    }

                    if (obj.floor && obj.floor.length > 0) {
                        copy.find('[data-ref=unit-floor]').text(obj.floor);
                    } else {
                        copy.find('[data-ref=unit-floor]').prev().remove();
                        copy.find('[data-ref=unit-floor]').remove();
                    }

                    if (obj.lease_rate) {
                        if (obj.lease_rate_units && mapFrequency(obj.lease_rate_units)) {
                            copy.find('[data-ref=unit-lease-rate]').text('$' + parseFloat(obj.lease_rate).toFixed(2) + '/' + mapFrequency(obj.lease_rate_units));
                        } else {
                            copy.find('[data-ref=unit-lease-rate]').text('$' + parseFloat(obj.lease_rate).toFixed(2));
                        }
                    } else {
                        copy.find('[data-ref=unit-lease-rate]').text('N/A');
                    }


                    copy.find('[data-ref=unit-type-title]').text(unit.charAt(0).toUpperCase() + unit.slice(1).toLowerCase());

                    if (obj.space_size && parseInt(obj.space_size) > 0) {
                        copy.find('[data-ref=unit-size]').text(obj.space_size);

                        if (obj.dimension) {
                            copy.find('[data-ref=unit-dimension]').text(obj.dimension && obj.dimension.toString() === 'SF' ? ' SF' : ' AC');
                        } else {
                            copy.find('[data-ref=unit-dimension]').text('');
                        }
                    } else {
                        copy.find('[data-ref=unit-size]').text('N/A');
                    }

                    if (leaseTypes[obj.lease_type]) {
                        copy.find('[data-ref=unit-lease-type]').text(leaseTypes[obj.lease_type]);
                    } else {
                        copy.find('[data-ref=unit-lease-type]').text('N/A');
                    }

                    var deal_status = unitDealStatus[obj.deal_status.toLowerCase()];

                    if (deal_status === 'Available') {
                        copy.find('[data-ref=unit-deal-status]').text(property.listing_type);
                    } else {
                        copy.find('[data-ref=unit-deal-status]').text(deal_status);
                    }

                    // Append the cloned unit to the list
                    ul.append(copy);
                });

                // Show the unit row
                wrapper.removeClass('hide');

                // Remove the clone
                clone.remove();

            } else {
                wrapper.addClass('hide');
            }


            // Hide empty rows
            $('.property dl dd').each(function () {
                if ($(this).text() === '' || $(this).text() === '0' || $(this).text() === '0 acres' || $(this).text() === '0 SF') {
                    $(this).addClass('hide');
                    $(this).prev('dt').addClass('hide');
                } else {
                    $(this).removeClass('hide');
                    $(this).prev('dt').removeClass('hide');
                }
            });

            var zoningEl = $('[data-ref="zoning_description"]');
            var zoningTxt = zoningEl.text();
            if (zoningTxt === '' || zoningTxt.length === 0) {
                zoningEl.parent().addClass('hide');
            } else {
                zoningEl.parent().removeClass('hide');
            }

            /*Images*/
            if (property.map_image_url.length > 0) {
                listingDetail.find('.content [data-ref=map_image_url]').css('background-image', 'url(' + Utils.imageUrl(property.map_image_url) + ')');
            } else {
                var map_image = MapController.Listings.getImage(property.street_address, property.city, property.state, property.id);

                if (map_image && map_image.length > 0) {
                    listingDetail.find('.content [data-ref=map_image_url]').css('background-image', 'url(' + map_image + ')');
                } else {
                    listingDetail.find('.content [data-ref=map_image_url]').css('background-image', '');
                }
            }

            var gallery = getGallery();

            if (property.uploaded_images && property.uploaded_images.length > 0) {
                var uploaded_images = property.uploaded_images.sort(function (obj1, obj2) {
                    return obj1.index - obj2.index;
                });

                $.each(uploaded_images, function (index, value) {
                    if (value.path) {
                        gallery.append('<a class="carousel-item"><img class="materialboxed" src="' + Utils.imageUrl(value.path) + '" onerror="Utils.replaceImage(this)"></a>');
                    }
                });
            } else {
                if (property.property_image_url && property.property_image_url.length > 0) {
                    gallery.append('<a class="carousel-item"><img class="materialboxed" src="' + Utils.imageUrl(property.property_image_url) + '" onerror="Utils.replaceImage(this)"></a>');
                } else {
                    gallery.append('<a class="carousel-item"><img class="materialboxed" src="' +$('body').attr('data-base-url')+ 'assets/img/no-photo-available.png"></a>');
                }
            }
            /*Broker section*/
            var broker = data.user;
            var secondary_brokers = data.secondary_brokers;

            //Broker > First & Lat Name
            if (broker.first_name && broker.first_name.length > 0 && broker.last_name && broker.last_name.length > 0) {
                listingDetail.find('.broker [data-ref=broker_name]').text(broker.first_name + " " + broker.last_name);
                listingDetail.find('.broker [data-ref=broker_name]').parent().find('strong').removeClass('hide');
            } else {
                listingDetail.find('.broker [data-ref=broker_name]').text('');
                listingDetail.find('.broker [data-ref=broker_name]').parent().find('strong').addClass('hide');
            }

            //Broker > Company Name
            if (data.company_name && data.company_name.length > 0) {
                listingDetail.find('.broker [data-ref=company_name]').parent().find('strong').removeClass('hide');
                listingDetail.find('.broker [data-ref=company_name]').text(data.company_name);
            } else {
                listingDetail.find('.broker [data-ref=company_name]').text('');
                listingDetail.find('.broker [data-ref=company_name]').parent().find('strong').addClass('hide');
            }

            //Broker > Secondary Brokers
            if (secondary_brokers && secondary_brokers.length > 0) {
                listingDetail.find('.broker [data-ref=secondary_brokers]').parent().removeClass('hide');
                var names = [];

                $(secondary_brokers).each(function(index, obj) {
                    names.push(obj.first_name + ' ' + obj.last_name);
                });

                listingDetail.find('.broker [data-ref=secondary_brokers]').html(names.join('<br/>'));
            } else {
                listingDetail.find('.broker [data-ref=secondary_brokers]').parent().addClass('hide');
                listingDetail.find('.broker [data-ref=secondary_brokers]').text('');
            }

            //Broker > Phone Number
            if (broker.phone_number && broker.phone_number.length > 0) {
                listingDetail.find('.broker [data-ref=phone_number]').parent().parent().find('strong').removeClass('hide');
                listingDetail.find('.broker [data-ref=phone_number]').attr('href', 'tel:' + broker.phone_number);
                listingDetail.find('.broker [data-ref=phone_number]').text(broker.phone_number);
            } else {
                listingDetail.find('.broker [data-ref=phone_number]').text('');
                listingDetail.find('.broker [data-ref=phone_number]').parent().parent().find('strong').addClass('hide');
            }

            if (broker.profile_image_url && broker.profile_image_url.length > 0) {
                listingDetail.find('.broker [data-ref=profile_image_url]').parent().removeClass('hide');
                listingDetail.find('.broker [data-ref=profile_image_url]').attr('src', body.attr('data-cdn-url') + broker.profile_image_url);
            } else {
                listingDetail.find('.broker [data-ref=profile_image_url]').attr('src', body.attr('data-base-url') + 'assets/img/User_default.png');
                listingDetail.find('.broker [data-ref=profile_image_url]').parent().addClass('hide');
            }

            listingDetail.find('.broker-listings [data-ref=broker-first-name]').text(broker.first_name);
            listingDetail.find('.broker-listings [data-ref=url-broker-id]').attr('href', body.attr('data-base-url') + 'listings?brokerId=' + broker.id);

            /*Contact section*/
            listingDetail.find('.contact [data-ref=brokerId]').val(data.brokerId);
            listingDetail.find('.contact [data-ref=propertyId]').val(data.propertyId);

            /*Related properties*/
            var relatedListings = $("#related-listing");
            relatedListings.empty();


            if (data.otherListings && data.otherListings.length > 0) {
                $('.broker-listings').show();
                $.each(data.otherListings, function (index, value) {
                    if (value.building_size_suites_parcels && value.building_size_suites_parcels.length > 0) {
                        value.building_size = value.building_size_suites_parcels;
                    }

                    var askingPriceOtherListing = 'Price Not Disclosed';
                    if (Utils.contains(value.listing_type, 'lease') && value.asking_price_psf) {
                        askingPriceOtherListing = value.asking_price_psf;
                    } else if (Utils.contains(value.listing_type, 'sale') && value.asking_price) {
                        askingPriceOtherListing = value.asking_price;
                    } else if (Utils.contains(value.listing_type, 'sale') && Utils.contains(value.listing_type, 'lease')) {
                        if (value.asking_price_psf) {
                            askingPriceOtherListing = value.asking_price_psf;
                        } else if (value.asking_price) {
                            askingPriceOtherListing = value.asking_price;
                        }
                    }

                    if (askingPriceOtherListing === 'Price Not Disclosed' && value.building_price_suites_parcels && parseInt(value.building_price_suites_parcels.replace(/\D/g, '')) > 0) {
                        askingPriceOtherListing = value.building_price_suites_parcels;
                    }

                    value.asking_price = askingPriceOtherListing;
                    var currentStreetAddress = value.street_address;

                    if (value.street_address && value.street_address.length > 0) {
                        value.street_address = currentStreetAddress;
                    } else if (value.business_name && value.business_name.length > 0) {
                        value.street_address = value.business_name;
                    } else {
                        value.street_address = "Address Not Disclosed";
                    }

                    var template = $('#related-listing-template').clone().html();


                    template = fill(value, template);
                    relatedListings.append(template);
                });
            } else {
                $('.broker-listings').hide();
                relatedListings.append("<span>This broker doesn't have other listings at this moment.</span>");
            }



            /*Steps*/
            var previousIndex = parseInt(data.index) - 1;
            var previousButton = listingDetail.find('a#previous-listing');
            previousButton.attr('data-index', previousIndex);

            if (previousIndex < 0) {
                previousButton.addClass('disabled');
            } else {
                previousButton.removeClass('disabled');
            }

            var nextIndex = parseInt(data.index) + 1;
            var nextButton = listingDetail.find('a#next-listing');
            nextButton.attr('data-index', nextIndex);

            var totalListings = parseInt($('[data-ref=total_of_listings]').attr('data-total'));

            if (nextIndex >= totalListings) {
                nextButton.addClass('disabled');
            } else {
                nextButton.removeClass('disabled');
            }

        } catch (err) {
            console.log('It is not possible to load the property at the moment.');
            console.log(err);
        }
    };

    var getGallery = function () {
        var gallery = $('#listing-detail .content [data-ref=gallery]');

        gallery.find('.carousel-item').remove();

        if (gallery.hasClass('initialized')) {
            gallery.removeClass('initialized');
        }
        return gallery;
    };

    var initContactBrokerForm = function () {
        $("button.submit-contact-broker-from-detail").click(function () {
            var form = $(this).parent().parent().parent();
            console.log(form);
            var button = $(this);
            event.preventDefault();
            try {
                if (form.valid()) {

                    button.attr("disabled", "disabled");
                    $('body').css('cursor', 'progress');

                    $.post(form.attr('action'), form.serializeArray())
                        .done(function (responseText) {
                            button.removeAttr('disabled');

                            $('body').css('cursor', 'auto');

                            var data = JSON.parse(responseText);
                            if (data.status === true) {
                                form[0].reset();
                                grecaptcha.reset(1);
                                grecaptcha.reset();
                                Materialize.toast(data.message, 4000);
                            }
                            if (data.status === "fail" && data.message=="verifying_CAPTCHA") {
                                $("p#contact_error").html("There was an error verifying the CAPTCHA. Please try again.");
                                $(".red-text").show();
                            }else if (data.status === "fail" && data.message=="fill_CAPTCHA") {
                                $("p#contact_error").html("Please select CAPTCHA.");
                                $(".red-text").show();
                            }else{
                                $(".red-text").hide();
                            }
                        });
                }
            } catch (err) {
                grecaptcha.reset(1);
                grecaptcha.reset();
                button.removeAttr('disabled');
                $('body').css('cursor', 'auto');
                form[0].reset();
            }
        });
    };

    var openPropertyDetails = function (element) {
        var propertyId = $(element).attr('data-id');
        var brokerId = $(element).attr('data-broker-id');
        var companyName = $(element).attr('data-company-name');
        var index = $(element).attr('data-index');

        if (propertyId && brokerId) {
            $.ajax({
                url: $("body").data("base-url") + 'mls/get_property_details',
                data: {propertyId: propertyId, brokerId: brokerId},
                beforeSend: function () {
                    openDrawer();
                },
                success: function (responseText) {
                    var data = JSON.parse(responseText);

                    data.company_name = companyName;
                    data.brokerId = brokerId;
                    data.propertyId = propertyId;
                    data.index = index;

                    fillDetails(data);
                }
            }).done(function (data) {
                initCarousel();
                closeDrawer();
                stopLoading('#listing-detail');
            });
        } else {
            console.log("[ERROR] It is not possible to show the property details at this moment.");
        }
    };

    var openDrawer = function () {

        $('.drawer').addClass('open');
        $('body').addClass('hide-overflow');
        window.scrollTo(0, 0);

        $("#listing-detail").LoadingOverlay("show",
            {
                image: $('body').attr('data-base-url') + "assets/img/loading.png",
                imageAnimation: '2500ms rotate_left',
                zIndex: 1002,
                background: "rgba(255, 255, 255, 0.95)"
            }
        );
    };

    var closeDrawer = function () {
        $('#listing-detail').LoadingOverlay("hide");
    };

    var loadListingDetails = function (event) {
        event.preventDefault();

        var element = $(event.target);
        var index = element.attr('data-index');

        var params = getParams();
        params.offset = index;
        params.limit = 1;

        if (!element.hasClass('disabled')) {
            $.ajax({
                url: $("body").data("base-url") + 'mls/get_next_or_previous_property',
                data: params,
                beforeSend: function () {
                    showListingDetailsOverlay();
                },
                success: function (responseText) {
                    var data = JSON.parse(responseText);
                    if (data.property && data.property.id) {
                        data.company_name = data.property.company_name;
                        data.index = index;
                        data.brokerId = data.user.id;
                        data.propertyId = data.property.id;

                        updateHash(data.property.id);

                        fillDetails(data);
                    }
                }
            }).done(function (data) {
                initCarousel();
                hideListingDetailsOverlay();
            });
        }
    };

    var initWizard = function () {
        $("#previous-listing, #next-listing").click(function (event) {
            loadListingDetails(event);
        });
    };

    var initMenu = function () {
        if ($('#mls-menu').length) {
            $('.button-collapse').sideNav({
                    menuWidth: 300, // Default is 300
                    edge: 'right', // Choose the horizontal origin
                    closeOnClick: true
                }
            );
        }
    };

    var initCarousel = function () {
        $('.carousel.carousel-slider').carousel({fullWidth: true});

        // move next carousel
        $('.moveNextCarousel').click(function (e) {
            e.preventDefault();
            e.stopPropagation();
            $('.carousel.carousel-slider').carousel('next');
        });

        // move prev carousel
        $('.movePrevCarousel').click(function (e) {
            e.preventDefault();
            e.stopPropagation();
            $('.carousel.carousel-slider').carousel('prev');
        });

        $('.materialboxed').materialbox();
    };

    var closePropertyDetails = function () {
        $('.drawer').removeClass('open');
        window.scrollTo(0, 0);
        setTimeout(function(){ $('body').removeClass('hide-overflow'); }, 1000);

        updateHash();
    };

    var openFullScreen = function () {
        $('main.listings').toggleClass('full-screen');
    };

    var checkHash = function () {
        try {
            var id = parseInt(window.location.hash.substr(1));
            if (!isNaN(id)) {
                $.get($("body").data("base-url") + 'mls/get_property_details', {
                    propertyId: id
                }).done(function (responseText) {
                    var data = JSON.parse(responseText);
                    if (data.property && data.property.id) {

                        data.company_name = data.property.company_name;
                        data.brokerId = data.user.id;
                        data.propertyId = data.property.id;
                        data.index = "1";

                        openDrawer();
                        fillDetails(data);
                        initCarousel();
                        closeDrawer();

                        //Clean the search hash, then add it again
                        cleanSearchQuery('' + id + '');
                        updateHash(id);
                    } else {
                        Materialize.toast('The property you are looking for is no longer listed.', 2000);
                    }
                });
            }
        } catch (err) {
            Materialize.toast('The property you are looking for is no longer listed.', 2000);
        }
    };

    var checkEmptyParams = function () {
        var params = getParams();
        for (var val in params) {
            if (params.hasOwnProperty(val)) {
                if (params[val] === undefined || params[val].length === 0) {
                    var queryName = val.split(/(?=[A-Z])/).join(" ").toLowerCase().replace(' ', '_');
                    cleanSearchQuery(queryName);
                }
            }
        }
    };

    var cleanHash = function () {
        var params = getParams();

        for (var val in params) {
            if (params[val] instanceof Array) {
                var data = params[val].join();
                var queryName = val.split(/(?=[A-Z])/).join(" ").toLowerCase().replace(' ', '_');

                for (var i = 0; i < params[val].length; i++) {
                    cleanSearchQuery(queryName + '[' + i + ']');
                }
                updateSearchQuery(queryName, data, true);
            }
        }
    };

    var updateHash = function (id) {
        if (id === undefined) {
            history.pushState("", document.title, window.location.pathname + window.location.search);
        } else {
            history.pushState("", document.title, window.location.pathname + window.location.search + "#" + id);
        }
    };

    var showListingDetailsOverlay = function () {
        $("#listing-detail").LoadingOverlay("show",
            {
                image: "assets/img/loading.png",
                imageAnimation: '2500ms rotate_left',
                zIndex: 1002,
                background: "rgba(255, 255, 255, 0.95)"
            }
        );
    };

    var hideListingDetailsOverlay = function () {
        $("#listing-detail").LoadingOverlay("hide");
    };

    if (window.MLSController === undefined) {
        window.MLSController = {};
    }

    var isLoadingListings = false;

    window.MLSController = {
        initialize: initialize,
        fill: fill,
        loadListings: loadListings,
        openPropertyDetails: openPropertyDetails,
        closePropertyDetails: closePropertyDetails,
        openFullScreen: openFullScreen,
        refreshScroll: refreshScroll,
        isLoadingListings: isLoadingListings,
        isInfiniteScroll: false
    };

    MLSController.initialize();
});

function initializeListingsMap() {
    MapController.Listings.init();
}


